import * as DOMElements from './DOMElements';
import Inputmask from "inputmask";

const isDebug = window.location.hash === "#debug" || window.location.hash === "debug";

const urls = {
    token: '/index.php?option=com_ajax&module=parpfaqwidget&method=GetToken&format=json',
    programs: '${api_url}api/getOperationalPrograms',
    subjects: '${api_url}api/getSubjects',
    intervals: '${api_url}api/getAvailableTimeInterval',
    reservation: '${api_url}api/confirmReservation',
};

export class CallToBack {
    token = null;
    my_super_secure_ip = '';
    __getting_token = false;

    retries = {
        token: 3,
        programs: 3,
        subjects: 3,
        intervals: 3,
    };

    constructor() {
        this.getToken();

        const api_url = DOMElements.callbackForm.action;
        for (let key in urls) {
            if (urls.hasOwnProperty(key)) {
                urls[key] = urls[key].replace('${api_url}', api_url);
            }
        }

        this.step = 1;

        DOMElements.callbackFormLoader.innerHTML = DOMElements.logoLoader;

        DOMElements.callbackFormBackButton.onclick = (e) => {
            e.preventDefault();
            this.previousStep();
        };

        DOMElements.callbackForm.onsubmit = this.onFormsubmit;

        DOMElements.callbackFormDay.onchange = this.onDayChange;

        const incomplete_phone_number_msg = 'Podaj poprawny numer telefonu';
        DOMElements.callbackFormPhone.setCustomValidity(incomplete_phone_number_msg);
        Inputmask({
            mask: ["(+48) 999 999 999"],
            oncomplete: (e) => {
                DOMElements.callbackFormPhone.setCustomValidity('');
            },
            onincomplete: (e) => {
                DOMElements.callbackFormPhone.setCustomValidity(incomplete_phone_number_msg);
            },
        }).mask(DOMElements.callbackFormPhone);
    }

    onFormsubmit = (e) => {
        e.preventDefault();
        this.nextStep();
    }

    nextStep = () => {
        if (isDebug) console.log("nextStep", this.step);
        if (this.step === 1) {
            if (DOMElements.callbackFormConditions.checked) {
                this.step++;
                DOMElements.callbackFormStep1.style.display = 'none';
                DOMElements.callbackFormStep2.style.display = 'block';

                this.getIntervals()
                    .then(interval_list => {
                            if (interval_list !== null) {
                                this.updateIntervals(interval_list);
                                const first_day = DOMElements.callbackFormDay.options[0];
                                const first_time_slot = DOMElements.callbackFormTimeslot.options[0];
                                if (first_day) {
                                    if (isDebug) console.log({first_day: first_day});
                                    first_day.selected = true;
                                }
                                if (first_time_slot) {
                                    if (isDebug) console.log({first_day: first_time_slot});
                                    first_time_slot.selected = true;
                                }
                                this.nextStep();
                            } else {
                                this.critical_failure();
                            }
                        }
                    );
            } else {
                DOMElements.callbackFormConditionsError.style.display = 'block';
            }
        } else if (this.step === 2) {
            this.step++;
            DOMElements.callbackFormStep2.style.display = 'none';
            DOMElements.callbackFormStep3.style.display = 'block';

            DOMElements.callbackFormDay.setAttribute('required', 'required');
            DOMElements.callbackFormTimeslot.setAttribute('required', 'required');
        } else if (this.step === 3) {
            DOMElements.callbackFormStep3.style.display = 'none';
            DOMElements.callbackFormStep4.style.display = 'block';
            this.setReservation().then(success => {
                if (isDebug) console.log("reservation success", success);
                DOMElements.callbackFormStep4.style.display = 'none';
                if (success) {
                    DOMElements.callbackFormStep5.style.display = 'block';
                } else {
                    DOMElements.callbackFormStep3.style.display = 'block';
                }
            });
        }
    }

    previousStep = () => {
        if (isDebug) console.log("previousStep", this.step);
        if (this.step === 3) {
            DOMElements.callbackFormStep3.style.display = 'none';
            DOMElements.callbackFormStep1.style.display = 'block';
        } else if (this.step === 2) {
            DOMElements.callbackFormStep2.style.display = 'none';
            DOMElements.callbackFormStep1.style.display = 'block';
        }

        this.step = 1;
        DOMElements.callbackFormDay.removeAttribute('required');
        DOMElements.callbackFormTimeslot.removeAttribute('required');
    }

    getToken = () => {
        return new Promise(resolve => {
            if (!this.__getting_token) {
                if (isDebug) console.log("Getting token...");
                this.__getting_token = true;
                this.token = null;
                fetch(urls.token)
                    .then(response => response.json())
                    .then((data) => {
                        if (data.success && data.data.token) {
                            this.token = data.data.token;
                            this.my_super_secure_ip = data.data.ip;
                        }
                        if (isDebug) console.log('Got token.', data);
                        this.__getting_token = false;
                        resolve(this.token);
                    });
            } else {
                const wait_for_token = () => {
                    if (!this.__getting_token) {
                        if (isDebug) console.log("Finally got token.");
                        resolve(this.token);
                    } else {
                        if (isDebug) console.log("Waiting for token...");
                        setTimeout(wait_for_token, 250);
                    }
                };
                wait_for_token();
            }
        });
    }

    getIntervals = () => {
        return new Promise(resolve => {
            fetch(urls.intervals, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        NumberOfDays: 7,  // API działa w taki sposób, że biorę tydzień kalendarzowy żeby mieć co wyświetlić
                    }),
                }
            )
                .then(response => {
                    if (response.status === 200) {
                        response.json().then((data) => {
                            if (data.IsOk) {
                                if (isDebug) console.log("getIntervals Intervals", data.Data);
                                resolve(data.Data);
                            } else {
                                this.retries.intervals--;
                                if (this.retries.intervals) {
                                    if (isDebug) console.log("getIntervals failed, trying in 3 seconds", data);
                                    setTimeout(() => {
                                        if (isDebug) console.log("getIntervals retring...");
                                        this.getIntervals();
                                    }, 3000);
                                } else {
                                    if (isDebug) console.log("getIntervals no more retries");
                                    resolve(null);
                                }
                            }
                        });
                    } else {
                        if (response.status === 401) {
                            if (isDebug) console.log("getIntervals", "Bad token. Getting new one.");
                            return this.getToken().then(() => {
                                this.getIntervals().then(interval_list => resolve(interval_list));
                            });
                        } else {
                            if (isDebug) console.log("getIntervals error", {response});
                        }
                        resolve(null);
                    }
                });
        });
    };

    setReservation = () => {
        return new Promise(resolve => {
            if (isDebug) console.log('setReservation');
            fetch(urls.reservation, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "FullName": DOMElements.callbackFormFullname.value,
                        "PhoneNumber": DOMElements.callbackFormPhone.value,
                        "Email": DOMElements.callbackFormEmail.value,
                        "IPAddress": this.my_super_secure_ip,
                        "IdTimeInterval": DOMElements.callbackFormTimeslot.value,
                        "QuestionCallback": DOMElements.callbackFormTopic.value,
                    }),
                }
            )
                .then(response => {
                    if (response.status === 200) {
                        response.json()
                            .then((data) => {
                                if (data.IsOk) {
                                    if (isDebug) console.log("setReservation Reservation", data);
                                    resolve(data.IsOk);
                                } else {
                                    this.retries.intervals--;
                                    if (this.retries.intervals) {
                                        if (isDebug) console.log("setReservation failed, trying in 3 seconds", data);
                                        setTimeout(() => {
                                            if (isDebug) console.log("setReservation retring...");
                                            this.setReservation();
                                        }, 3000);
                                    } else {
                                        if (isDebug) console.log("setReservation no more retries");
                                        DOMElements.callbackFormError.innerText = data.ErrorDescription;
                                        resolve(null);
                                    }
                                }
                            });
                    } else {
                        if (response.status === 401) {
                            if (isDebug) console.log("setReservation", "Bad token. Getting new one.");
                            return this.getToken().then(() => {
                                this.setReservation().then(result => resolve(result));
                            });
                        } else {
                            if (isDebug) console.log("setReservation error", {response});
                        }
                        resolve(null);
                    }
                });
        });
    };

    updateIntervals = (iterval_list) => {
        const select_days = DOMElements.callbackFormDay;
        const select_timeslots = DOMElements.callbackFormTimeslot;

        [...select_days.options].forEach(option => {
            select_days.removeChild(option);
        });
        [...select_timeslots.options].forEach(option => {
            select_timeslots.removeChild(option);
        });

        iterval_list.forEach((interval, idx) => {
            const option_day = document.createElement('option');
            option_day.value = interval.Day;
            const labels = this.get_date_labels(interval.Day);
            option_day.innerText = labels.visible;
            option_day.setAttribute('aria-label', labels.aria);
            if (idx === 0) {
                option_day.selected = true;
            }
            select_days.appendChild(option_day);
            interval.TimeIntervals.forEach((timeslot) => {
                const option_timeslot = document.createElement('option');
                option_timeslot.value = timeslot.Id;
                option_timeslot.innerText = timeslot.HourlyInterval;
                option_timeslot.dataset.day = interval.Day;
                if (idx > 0) {
                    option_timeslot.setAttribute('hidden', 'hidden');
                }
                select_timeslots.appendChild(option_timeslot);
            });
        });
    };

    get_date_labels = (date_string) => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        const date = new Date(date_string);

        if (today.getFullYear() === date.getFullYear() && today.getMonth() === date.getMonth() && today.getDate() === date.getDate()) {
            return {
                visible: "Dzisiaj",
                aria: "Dzisiaj",
            };
        }
        if (tomorrow.getFullYear() === date.getFullYear() && tomorrow.getMonth() === date.getMonth() && tomorrow.getDate() === date.getDate()) {
            return {
                visible: "Jutro",
                aria: "Jutro",
            };
        }

        const day = [
            'Niedziela',
            'Poniedziałek',
            'Wtorek',
            'Środa',
            'Czwartek',
            'Piątek',
            'Sobota'
        ][date.getDay()];

        const day_short = [
            'Nd.',
            'Pn.',
            'Wt.',
            'Śr.',
            'Cz.',
            'Pt.',
            'Sb.'
        ][date.getDay()];

        const month = [
            'Stycznia',
            'Lutego',
            'Marca',
            'Kwietnia',
            'Maja',
            'Czerwca',
            'Lipca',
            'Sierpnia',
            'Września',
            'Października',
            'Listopada',
            'Grudnia',
        ][date.getMonth()];

        let formatted_day = date.getDate();
        if (formatted_day < 10) formatted_day = `0${formatted_day}`;
        let formatted_month = date.getMonth() + 1;
        if (formatted_month < 10) formatted_month = `0${formatted_month}`;
        let formatted_year = date.getFullYear().toString().slice(2);

        return {
            visible: `${day} ${formatted_day}.${formatted_month}.${formatted_year}`,
            aria: `${day}, ${date.getDate()} ${month} ${date.getFullYear()}`,
        }
    };

    date_name = (date_string) => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        const date = new Date(date_string);

        if (today.getFullYear() === date.getFullYear() && today.getMonth() === date.getMonth() && today.getDate() === date.getDate()) {
            return "Dzisiaj";
        }
        if (tomorrow.getFullYear() === date.getFullYear() && tomorrow.getMonth() === date.getMonth() && tomorrow.getDate() === date.getDate()) {
            return "Jutro";
        }

        const day = [
            'Nd',
            'Pn',
            'Wt',
            'Śr',
            'Cz',
            'Pt',
            'Sb'
        ][date.getDay()];

        const month = [
            'Stycznia',
            'Lutego',
            'Marca',
            'Kwietnia',
            'Maja',
            'Czerwca',
            'Lipca',
            'Sierpnia',
            'Września',
            'Października',
            'Listopada',
            'Grudnia',
        ][date.getMonth()];

        return `${day} ${date.getDate()} ${month}`;
    };

    onDayChange = (e) => {
        if (isDebug) console.log("onDayChange", e.target.value);
        const select_timeslots = DOMElements.callbackFormTimeslot;
        const day = e.target.value;
        let changed_timeslot = false;
        [...select_timeslots.options].forEach(option => {
            if (option.dataset.day === day) {
                option.removeAttribute('hidden');
                if (!changed_timeslot) {
                    changed_timeslot = true;
                    select_timeslots.value = option.value;
                }
            } else {
                option.setAttribute('hidden', 'hidden');
            }
        });
    };

    critical_failure = () => {
        DOMElements.callbackForm.innerHTML = "Przepraszamy, funkcja chwilowo nie działa. Prosimy spróbować później";
    };
}
